import { Component, Input } from '@angular/core';
import { HeadingSize } from '../../models';

@Component({
  selector: 'lib-page-heading',
  templateUrl: 'page-heading.component.html',
})
export class PageHeadingComponent {
  @Input() text!: string;
  @Input() size: HeadingSize = HeadingSize.H1;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  HeadingSize = HeadingSize;
}
